import { Product } from "@protos/common/v1/common";

import { createMappers } from "../bidirectionalMap";

export type ProductString = "sast" | "sca" | "secrets";

const products: Record<ProductString, Product> = {
  sast: Product.SAST,
  sca: Product.SCA,
  secrets: Product.SECRETS,
};

const [leftToRight, rightToLeft] = createMappers(products);

export const stringToProduct = leftToRight;
export const productToString = rightToLeft;
